var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.list,"item-text":"name","item-value":"term_id","color":"#f36d62","item-color":"#f36d62","label":_vm.placeholder,"clearable":"","flat":"","small-chips":"","outlined":"","rounded":"","multiple":"","chips":"","menu-props":{ top: false, offsetY: true }},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{staticClass:"white--text",attrs:{"color":"#f36d62"}},[_vm._v(_vm._s(item.name))])]}}]),model:{value:(_vm.selectedTags),callback:function ($$v) {_vm.selectedTags=$$v},expression:"selectedTags"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c1ccf5c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectTags.vue
// module id = 40
// module chunks = 0